import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { ChatMessage } from '../Chat'

@InputType()
export class AddChatInternalNoteArgs extends ActionArgs {
  @Field(() => ID)
  chatId: string

  @Field(() => String)
  content: string
}

export interface IAddChatInternalNote extends IAction<ChatMessage, AddChatInternalNoteArgs> {}
